import { render } from "./MoveLocation.vue?vue&type=template&id=2460721b"
import script from "./MoveLocation.vue?vue&type=script&lang=js"
export * from "./MoveLocation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__